/**
 * @generated SignedSource<<a8803a1c4479a87fb6f25b0616f811dc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useDeleteWidgetMutation$variables = {
  storecastId: string;
  widgetId: string;
};
export type useDeleteWidgetMutation$data = {
  readonly dashboard: {
    readonly deleteWidget: {
      readonly id: string;
      readonly widgets: ReadonlyArray<{
        readonly id: string;
      } | null>;
    };
  };
};
export type useDeleteWidgetMutation = {
  response: useDeleteWidgetMutation$data;
  variables: useDeleteWidgetMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storecastId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "widgetId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "dashboardId",
    "variableName": "storecastId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "widgetId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDeleteWidgetMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DashboardMutation",
        "kind": "LinkedField",
        "name": "dashboard",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "Dashboard",
            "kind": "LinkedField",
            "name": "deleteWidget",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "widgets",
                "plural": true,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useDeleteWidgetMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DashboardMutation",
        "kind": "LinkedField",
        "name": "dashboard",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "Dashboard",
            "kind": "LinkedField",
            "name": "deleteWidget",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "widgets",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c3a317bde4ced7dbf33208d298f87639",
    "id": null,
    "metadata": {},
    "name": "useDeleteWidgetMutation",
    "operationKind": "mutation",
    "text": "mutation useDeleteWidgetMutation(\n  $storecastId: ID!\n  $widgetId: ID!\n) {\n  dashboard(dashboardId: $storecastId) {\n    deleteWidget(id: $widgetId) {\n      id\n      widgets {\n        __typename\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6b9fa05e0ca82cf9be8c3312297c80dd";

export default node;
